import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import "./LoginPage.css";
import Loader from "../../common/Loader";
import { ResetPassword } from "../../services/AuthService";
import { Navigate, useNavigate } from "react-router-dom";
import * as Constants from "./LoginPageConstant";
import LoginPageData from "./LoginPage";

const carouselData = [
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: Constants.carouselData[0].title,
    text: Constants.carouselData[0].text,
  },
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: Constants.carouselData[1].title,
    text: Constants.carouselData[1].text,
  },
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: Constants.carouselData[2].title,
    text: Constants.carouselData[2].text,
  },
];

const LoginPage: React.FC<any> = ({ deviceId, deviceName, onLoginSuccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [messageType, setMessageType] = useState<string>("error");
  const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
  const [isSubmit, setisSubmit] = useState(false);
  const { name: username, Pass: password } = useSelector(
    (state: RootState) => state.form
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [userId, setuserId] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [validationMessage, setValidationMessage] = useState<string>("");
  const [token, setToken] = useState<string | null>(null);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const tokenValue = params.get("token");
    if (tokenValue) {
      setToken(tokenValue);
      setNewPassword("");
      setConfirmPassword("");
    }
  }, []);

  const handleIndicatorClick = (index: number) => {
    setCurrentIndex(index);
  };

  const handlePasswordUpdate = async () => {
    setLoading(true);
    const validationMessages: string[] = [];
    const passwordCriteriaRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\W_]{8,}$/;

    try {
      // Validate new password
      if (!newPassword) {
        validationMessages.push(Constants.validationMessages.newPassword);
        setMessageType("error");
      } else if (!passwordCriteriaRegex.test(newPassword)) {
        validationMessages.push(Constants.validationMessages.passwordError);
        setMessageType("error");
      }

      // Validate confirm password
      if (!confirmPassword) {
        validationMessages.push(Constants.validationMessages.confirmpassword);
        setMessageType("error");
      } else if (newPassword !== confirmPassword) {
        validationMessages.push(Constants.validationMessages.passwordMismatch);
        setMessageType("error");
      }

      if (validationMessages.length > 0) {
        setValidationMessage(validationMessages.join(" "));
        setLoading(false);
        return;
      }

      if (token) {
        try {
          const response = await ResetPassword(confirmPassword, token);

          if (response.isSuccess) {
            if (response.result.responseCode == "1") {
              setValidationMessage(
                Constants.validationMessages.passwordChanged
              );
              setIsPasswordUpdated(true);
              setisSubmit(true);
              setMessageType("success");
            } else if (response.result.responseCode == "5") {
              setValidationMessage(Constants.validationMessages.reusedPassword);
              setMessageType("error");
            } else if (response.result.responseCode == "4") {
              setValidationMessage("Old and New Password cannot be same.");
              setMessageType("error");
            } else {
              setValidationMessage("Failed to update password.");
              setMessageType("error");
            }
          }
        } catch (error) {
          setValidationMessage(
            "An error occurred while updating the password. Please try again."
          );
          setMessageType("error");
        }
      }
    } catch (error) {
      setValidationMessage("An unexpected error occurred.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-100">
      <Loader isLoading={loading} />
      {validationMessage && (
        <div
          className={`alert d-flex justify-content-between align-items-start mx-auto ${
            messageType === "success" ? "alert-success" : "alert-danger"
          }`}
        >
          <div className="me-auto">
            <div>
              {validationMessage.split("\n").map((msg, index) => (
                <span key={index} style={{ display: "block" }}>
                  {msg}
                </span>
              ))}
            </div>
          </div>
          <button
            type="button"
            className="btn-close bg-dark ms-3 p-1"
            aria-label="Close"
            onClick={() => setValidationMessage("")}
          >
            <span className="material-icons">close</span>
          </button>
        </div>
      )}

      <div className="d-flex h-100">
        <div className="carousel flex-fill  d-flex align-items-top justify-content-center">
          <img
            id="carouselImage"
            src={carouselData[currentIndex].image}
            alt="Carousel"
            className="w-65"
          />
          <h2 id="carouselTitle">{carouselData[currentIndex].title}</h2>
          <p id="carouselText">{carouselData[currentIndex].text}</p>
          <div className="indicators my-3">
            {carouselData.map((_, index) => (
              <div
                key={index}
                className={`indicator ${
                  currentIndex === index ? "active" : ""
                }`}
                onClick={() => handleIndicatorClick(index)}
              ></div>
            ))}
          </div>
          <p className="copyright">{Constants.footerText}</p>
        </div>

        <div className="login-container flex-fill  d-flex align-items-center justify-content-center">
          <div className="border col-md-8 col-xl-7 col-xxl-6 px-4 py-3 d-flex flex-column loginContainer">
            <div className="text-center mx-auto">
              <img
                id="loginLogo"
                src={require("../../modules/login/LoginImage/loginLogo.png")}
                alt="Logo"
              />
              <img
                id="carouselImage"
                src={carouselData[currentIndex].image}
                alt="Carousel"
                className="w-65 carousel-main-image my-4"
              />
            </div>

            <form>
              <div className="changepassword">Forgot Password</div>
              <div className="form-floating mb-1">
                <input
                  type={showNewPassword ? "text" : "password"}
                  className="form-control"
                  id="newPassword"
                  placeholder="New Password"
                  value={newPassword}
                  maxLength={30}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <label htmlFor="newPassword">New Password</label>
                <span
                  className="toggle-password"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                >
                  {showNewPassword ? (
                    <span className="material-icons">visibility</span>
                  ) : (
                    <span className="material-icons">visibility_off</span>
                  )}
                </span>
              </div>
              <div className="form-floating mb-3">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control"
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  maxLength={30}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <label htmlFor="confirmPassword">Confirm Password</label>
                <span
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                >
                  {showConfirmPassword ? (
                    <span className="material-icons">visibility</span>
                  ) : (
                    <span className="material-icons">visibility_off</span>
                  )}
                </span>
              </div>
              <div className="passwordcriteria">
                <p className="mb-0">Password Must:</p>
                <ul>
                  <li>Include lower and Upper character</li>
                  <li>Include at least 1 number or symbol</li>
                  <li>Be at least 8 characters long</li>
                  <li>Match in both fields</li>
                </ul>
              </div>
              {isPasswordUpdated ? (
                <div className="text-center mb-2">
                  <a
                    className="text-center"
                    href="http://192.168.10.94:7011/#/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click here to Login
                  </a>
                </div>
              ) : null}

              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handlePasswordUpdate}
                  disabled={isSubmit}
                >
                  Submit
                </button>
              </div>
            </form>
            <div className="mt-auto">
              <div className="footer text-center mt-3">
                <p>{Constants.termsAndPolicyText}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
